export default __webpack_public_path__ + "static/media/recycling.072ca190.jpg";